import EventsKeywordFilter from './EventsKeywordFilter';
import EventListingService from './api/EventListingService';
import EventsCalendarView from './calendarView/EventsCalendarView';
import CalendarViewMode from './calendarView/EventsCalendarViewMode';
import EventsListView from './listView/EventsListView';
import EventListingLegend from './EventListingLegend';
import PrimaryViewToggle from './PrimaryViewToggle';
import ViewMode from './EventListingViewMode';
import DateFormat from './date/EventListingDateFormat';
import DateFormatter from './date/EventListingDateFormatter';
import UrlSearchParamsConfig from './UrlSearchParamsConfig';
import { parseYYYYMMDD } from './date/DateHelpers';

class EventListing {
  constructor(constructorOptions = {}, dateFormats = {}) {
    const defaults = {
      calendarViewMode: CalendarViewMode.MONTH,
      defaultView: ViewMode.CALENDAR,
      additionalApiData: {},
    };

    const convertedDates = {
      defaultDisplayDate: parseYYYYMMDD(constructorOptions.defaultDisplayDate),
      earliestEventDate: parseYYYYMMDD(constructorOptions.earliestEventDate),
      latestEventDate: parseYYYYMMDD(constructorOptions.latestEventDate),
      listingStartDate: parseYYYYMMDD(constructorOptions.listingStartDate),
      listingEndDate: parseYYYYMMDD(constructorOptions.listingEndDate),
    };

    // Merge config sources in the following order:
    const config = Object.assign(
      defaults,
      constructorOptions,
      convertedDates,
      UrlSearchParamsConfig,
    );

    config.additionalApiData.keywordIds = config.keywordIds;

    DateFormatter.setDateFormats(dateFormats);
    EventListingService.setAdditionalApiData(config.additionalApiData);

    const { isMultiMode, defaultView } = config;

    const keywordFilter = new EventsKeywordFilter(config);
    const viewToggle = new PrimaryViewToggle(defaultView, isMultiMode);

    const primaryViews = [];

    if (isMultiMode || defaultView === ViewMode.LIST) {
      primaryViews.push(new EventsListView(config, keywordFilter, viewToggle));
    }
    if (isMultiMode || defaultView === ViewMode.CALENDAR) {
      primaryViews.push(new EventsCalendarView(config, keywordFilter, viewToggle));
    }

    viewToggle.notify();

    EventListingLegend.init();
  }
}

EventListing.ViewMode = ViewMode;
EventListing.DateFormat = DateFormat;

window.tnew.EventListing = EventListing;

export default EventListing;
